<form [formGroup]="form" class="js-form-general-information">
  <div class="row">
    <div class="col-12 col-md-3">
      <div class="form-group">
        <countries-dropdown
          [isocode]="country?.isocode"
          [countries$]="countries$"
          (_onSelectCountry)="setCountry($event)"
          [form]="form"
        ></countries-dropdown>

        <cx-form-errors [control]="form.get('country')?.get('isocode')!"></cx-form-errors>
      </div>
    </div>

    <div class="col-12 col-md-3">
      <div class="form-group">
        <label>
          <span class="label-content">{{ 'quotes.email' | cxTranslate }}</span>
          <input class="form-control" type="email" placeholder="Enter your email" formControlName="emailId" />
        </label>
        <cx-form-errors [control]="form.get('emailId')"></cx-form-errors>
      </div>
    </div>

    <div class="col-12 col-md-3">
      <div class="form-group">
        <label>
          <span class="label-content">{{ 'quotes.endCustomer' | cxTranslate }}</span>
          <input class="form-control" type="text" placeholder="Enter end customer" formControlName="endCustomer" [maxlength]="40" />
        </label>
        <cx-form-errors [control]="form.get('endCustomer')"></cx-form-errors>
      </div>
    </div>

    <div class="col-12 col-md-3">
      <div class="form-group">
        <label>
          <span class="label-content">{{ 'quotes.competitor' | cxTranslate }}</span>
          <input class="form-control" type="text" placeholder="Enter competitor" formControlName="competitor" [maxlength]="40" required />
        </label>
        <cx-form-errors [control]="form.get('competitor')"></cx-form-errors>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label>
          <span class="label-content">{{ 'quotes.additionalInformation' | cxTranslate }}</span>
          <textarea class="form-control" rows="3" formControlName="additionalInformation" [maxlength]="2000"></textarea>
        </label>

        <span class="h7"> {{ form.get('additionalInformation')?.value?.length ?? 0 }} / 2000 </span>

        <cx-form-errors [control]="form.get('additionalInformation')"></cx-form-errors>
      </div>
    </div>

    <div class="col-12 col-md-6 m-t-4">
      <drag-and-drop (_onValidateFiles)="setFiles($event)" [clearFiles$]="clearFiles$"></drag-and-drop>
    </div>
  </div>
</form>
